import { create } from 'zustand';
import { createJSONStorage, persist, devtools } from 'zustand/middleware';
import { ROROTEL_ACCESS_TOKEN } from '../../helpers/globalConstants';

const initialState = {
  userId: null,
  token: null,
  role: null,
  logo: null,
  companyName: null,
  accessControl: [],
};

export const useAuth = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setToken: (token) => set(() => ({ token })),
        setUserId: (userId) => set(() => ({ userId })),
        setAccesRole: (role) => set(() => ({ role })),
        setLogo: (logo) => set(() => ({ logo })),
        setCompanyName: (companyName) => set(() => ({ companyName })),
        setAccesControl: (accessControl) => set(() => ({ accessControl })),
        clearToken: () => {
          localStorage.clear();
          sessionStorage.clear();
          set(() => initialState);
        },
      }),
      {
        name: ROROTEL_ACCESS_TOKEN,
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
);
